<template>
<div>
  <!-- View data modal template -->
  <b-modal ref="view-lb" hide-footer @hide="hideLBModal">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('maintenance.organizations.view.title') }}
      </h4>
    </div>
    <b-alert v-if="error.length"
             show
             variant="danger"
             qid="create-p-error"
    >
      {{ error }}
    </b-alert>

    <label class="mt-3" v-if="object.organization && object.organization.name">
      {{ $t('maintenance.organizations.create.name_label') }}
    </label>
    <br>
    <span v-if="object.organization && object.organization.name">
      {{ object.organization.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.organization && object.organization.organization_level">
      {{ $t('activities.organizations.table.level') }}
    </label>
    <br>
    <span class="badge badge-info" v-if="object.organization && object.organization.organization_level">
      {{ $t('activities.create.organizations_level') }} {{ object.organization.organization_level }}
    </span>
    <br>

    <label class="mt-3" v-if="object.organization && object.organization.linkedOrganization">
      {{ $t('activities.organizations.table.linked_organization') }}
    </label>
    <br>
    <span v-if="object.organization && object.organization.linkedOrganization">
      {{ object.organization.linkedOrganization.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.organization && object.organization.description">
      {{ $t('maintenance.organizations.create.description_label') }}
    </label>
    <br>
    <span v-if="object.organization && object.organization.description" class="text-formatted">
      {{ object.organization.description }}
    </span>
    <br>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hideLBModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.legal_basis.view.close') }}
    </b-button>
    <br>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'OrganizationViewModal',
    data: function() {
      return {
        inputLink: '',
        selectedArticle: [],
        articles: [],
        error: '',
        showInput: false,
        showSingleLinkLabel: true,
        loadingItems: false,
        showArticleDescription: false,
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showLBModal()
        }
      }
    },
    methods: {
      showLBModal() {
        let self = this
        this.$refs['view-lb'].show()
      },
      hideLBModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-lb'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
